'use client'
/**
 * @typedef {import("@prismicio/client").Content.TestimonialSlice} TestimonialSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<TestimonialSlice>} TestimonialProps
 * @param {TestimonialProps}
 */

import { PrismicImage, PrismicRichText } from "@prismicio/react";
import React, { use, useState } from "react";

const TestimonialMobile = ({ testimonial, bg_color }) => {
  return <div className="snap-center snap-always">
    <div
      className={`w-[300px] h-[400px] flex flex-col justify-between  ${bg_color ? ' bg-pink' : 'bg-green'} p-30px border-0 rounded-t-30px`}>
      <div className="small">
        <PrismicRichText field={testimonial.text} />
      </div>
      <div className="text-info">
        <PrismicRichText field={testimonial.name} />
      </div>
    </div>
    <div>
      <PrismicImage
        field={testimonial.picture}
        className="w-[300px] h-[230px] object-cover" loading="lazy"/>
    </div>
  </div>
}


const TestimonialDesktop = ({ testimonials }) => {

  const [selected, setSelected] = useState(0);
  const [toggled, setToggle] = useState(true)

  function prev() {
    if (selected - 1 < 0) {
      setSelected(testimonials.length - 1)
      setToggle(!toggled)
    } else {
      setSelected(selected - 1)
      setToggle(!toggled)
    }
  }

  function next() {
    if (selected + 1 > testimonials.length - 1) {
      setSelected(0)
      setToggle(!toggled)
    } else {
      setSelected(selected + 1)
      setToggle(!toggled)
    }
  }

  return <React.Fragment>
    <div className="flex mt-3">
      <div className="mr-10">
        <div className="w-[373px] h-[456px] border-0 mb-12 lg:mb-16 relative content-parent-testimonial">
          {
            testimonials.map((testimonial, i) => {
              return <div key={i} className={`w-full h-full content-testimonial content-testimonial-${i} rounded-30px p-30px ${i % 3 == 0 ? 'bg-dark-green' : i % 2 ? 'bg-dark-pink' : 'bg-dark-beige'} ${i == selected ? "" : 'hidden'}`}>
                <div className="flex flex-col justify-between h-full">
                  <div className="pb-12">
                    <PrismicRichText field={testimonial.text} />
                  </div>
                  <div className="text-info">
                    <PrismicRichText field={testimonial.name} />
                  </div>
                </div>
              </div>
            })
          }
          <div className="w-fit absolute right-30px -bottom-[25px] flex testimonial-arrow">
            <span className="mr-[25px] left cursor-pointer" onClick={prev}>
              <img src="svg/arrow-left.svg" loading="lazy" className="w-[50px] h-[50px]" alt="flèche gauche"/>
            </span>
            <span className="right cursor-pointer" onClick={next}>
              <img src="svg/arrow-right.svg" loading="lazy" className="w-[50px] h-[50px]" alt="flèche droite"/>
            </span>
          </div>
        </div>
        <div className="w-fit m-auto testimonial-dots">
          {
            testimonials.map((_, i, arr) => {
              if (i < arr.length) {
                return <div key={i} className={`dot mx-2 ${i === selected ? " active" : ""}`}></div>
              }
            })
          }
        </div>
      </div>
      <div className={`w-[325px] h-[456px] lg:w-[375px] lg:h-[506px] image-testimonial-container overflow-hidden z-10 ${toggled ? 'img-tr' : 'img-bl'}`}>
        <div className="relative">
          {
            testimonials.map((testimonial, i) => {
              return <PrismicImage key={i} field={testimonial.picture} loading="lazy"
                className={`w-[325px] h-[456px] lg:w-[375px] lg:h-[506px] object-cover absolute ${i == selected ? 'opacity-100' : 'opacity-0'} image-testimonial image-testimonial-${i} z-1`} />
            })}
        </div>
      </div>
    </div>
  </React.Fragment >
}

const Testimonial = ({ slice, index }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`overflow-hidden relative ${index !== 0 ? 'border-t-2 border-dark-grey' : ''}`}>
      <div className="bg-grain w-full h-full absolute top-0"></div>
      <div className="pt-30px pb-14 md:py-20 lg:py-28 md:px-7 lg:px-10 text-dark-grey relative z-[10]">
        <div className="max-w-[1300px] m-auto lg:flex justify-between">
          <div className="md:mb-10 lg:mb-0 lg:w-[375px] lg:mr-10 mb-6 px-4 md:px-0">
            <h2 className="subtitle mb-5">
              {slice.primary.seo_title}
            </h2>
            <div className="h2-like mr-[40px]">
              <PrismicRichText field={slice.primary.title} />
            </div>
          </div>
          <div className="flex md:hidden w-full gap-4 px-4 md:px-0 md:gap-7 snap-x snap-mandatory overflow-x-auto no-scrollbar">
            {slice.primary.testimonials.map((testimonial, i) => <TestimonialMobile key={i} testimonial={testimonial} bg_color={i % 2 === 1} />)}
          </div>
          <div className="hidden md:block">
            <TestimonialDesktop testimonials={slice.primary.testimonials} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
